namespace GeniuzPOS.CustomReport {
    export namespace PermissionKeys {
        export const Report = "";

        namespace Report_StockOnHand {
            export const View = "6CustomReport:StockOnHand:View";
        }

        namespace Report_SaleReport {
            export const View = "6CustomReport:Sale Report:View";
        }

        namespace Report_PromotionSale {
            export const View = "6CustomReport:Promotion Sale:View";
        }

        namespace Report_AgingReport {
            export const View = "6CustomReport:Aging Report:View";
        }

        namespace Report_SaleComparison {
            export const View = "6CustomReport:SaleComparison:View";
        }
    }
}
